const problemsWithProductData = escalatedComplaintsEnabled => {
  let options = {
    id: "problemsWithProduct",
    type: "select",
    select: {
      label: "What can we help with?",
      options: [
        {
          value: null,
          label: "Select a subject",
        },
        {
          value: "furnitureDamagedOnDelivery",
          label: "Furniture was damaged when delivered",
        },
        {
          value: "furnitureProductFault",
          label: "Furniture has a fault",
        },
        {
          value: "electrical",
          label: "Electrical product has a fault",
        },
        {
          value: "problemsOther",
          label: "Other",
        },
      ],
    },
  };
  if (escalatedComplaintsEnabled) {
    const selectedIndex = options.select.options.findIndex(option => option.value === "problemsOther");
    const newOptions = [
      {
        value: "infestation",
        label: "Infestation",
      },
    ];
    options.select.options = [
      ...options.select.options.slice(0, selectedIndex),
      ...newOptions,
      ...options.select.options.slice(selectedIndex),
    ];
  }
  return options;
};

export default problemsWithProductData;
